<template>
  <div id="app">
    <router-view />
    <div class="build-tag">{{ gitCommit }}</div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import api from '@/api'
import { setMachineRegistry } from '@/utils/machineNames'

export default {
  name: 'App',
  data() {
    return { gitCommit: process.env.VUE_APP_GIT_COMMIT || 'dev' }
  },
  created() {
    this.checkAuth()
    this.loadMachines()
  },
  methods: {
    ...mapActions(['checkAuth']),
    async loadMachines() {
      // Warm the machine-name registry (#40). Best-effort: the static map in
      // machineNames.js remains the fallback if this fails or runs pre-login.
      if (!localStorage.getItem('token')) return
      try {
        const res = await api.get('machines')
        setMachineRegistry(res.data || [])
      } catch (e) {
        // ignore — fall back to the static DISPLAY_MAP
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
}
.build-tag {
  display: block;
  text-align: right;
  padding: 4px 6px;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.2);
  font-family: monospace;
  user-select: none;
}
</style>
